import React from "react";
import { useTranslation } from "react-i18next";
import LanguageToggle from "./LanguageToggle";
import BrandMark from "./BrandMark";
import LegalFooter from "./LegalFooter";

/* Used by Login / Register / Forgot / Reset pages. Split-screen on md+. */
export default function AuthLayout({ title, subtitle, children, footer }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen w-full flex bg-bg-void app-grain" data-testid="auth-layout">
      {/* Form side */}
      <div className="relative z-10 flex-1 flex flex-col">
        <header className="flex items-center justify-between px-6 py-5 md:px-10 md:py-6">
          <BrandMark />
          <LanguageToggle />
        </header>

        <main className="flex-1 flex items-center justify-center px-6 pb-12">
          <div className="w-full max-w-[420px]">
            <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-ink-primary mb-2">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-ink-secondary mb-8 leading-relaxed">{subtitle}</p>
            )}
            {children}
            {footer && <div className="mt-6 text-sm text-ink-secondary">{footer}</div>}
          </div>
        </main>

        <footer className="px-6 md:px-10 py-5 text-xs text-ink-muted flex items-center justify-between">
          <span>© {new Date().getFullYear()} StudioOps Food</span>
          <span className="hidden sm:inline">{t("app.tagline")}</span>
        </footer>
        <LegalFooter />
      </div>

      {/* Visual side */}
      <aside className="hidden lg:block flex-1 relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url(https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-bg-void via-bg-void/85 to-transparent" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(59,130,246,0.18),transparent_55%)]" />

        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-ink-secondary">
            <span className="w-6 h-px bg-ink-secondary" />
            B2B SaaS · DACH
          </div>
          <div className="max-w-md">
            <h2 className="font-display text-3xl font-semibold text-ink-primary leading-tight mb-3">
              Wareneinsatz, Food Cost &amp; AI Rezepte — präzise kalkuliert.
            </h2>
            <p className="text-sm text-ink-secondary leading-relaxed">
              Für Restaurants, Bars und Hotels in Österreich, Deutschland und der Schweiz.
              Eine Plattform für die gesamte Küchen- und Bar-Wirtschaftlichkeit.
            </p>
          </div>
          <div className="flex items-center gap-6 text-[11px] uppercase tracking-[0.2em] text-ink-secondary">
            <span>Food Cost</span>
            <span className="w-1 h-1 rounded-full bg-brand" />
            <span>F&amp;B Intelligence</span>
            <span className="w-1 h-1 rounded-full bg-brand" />
            <span>Halbpension</span>
          </div>
        </div>
      </aside>
    </div>
  );
}
